/**
 * What the portal switcher puts in front of a person.
 *
 * A portal's CODE is unique; its NAME is not. The switcher rendered names alone, so a database
 * carrying two portals called "Australia Wholesale" produced two identical options — no way to
 * tell them apart, and no way to know you had landed on the other one. That is a real state: a
 * local database had exactly it, from two generations of fixtures, and nothing in the schema
 * prevents it anywhere else.
 *
 * The code is appended ONLY where it disambiguates. Showing it always would put "Australia
 * Wholesale (aus)" in front of everyone who has one Australia and no question to answer.
 */
export function portalOptionLabel(
  portal: { name: string; code: string },
  all: ReadonlyArray<{ name: string }>,
): string {
  const sameName = all.filter((p) => p.name === portal.name).length > 1;
  return sameName ? `${portal.name} (${portal.code})` : portal.name;
}
